export interface PriceIndicatorStyleOption {
  title: string;
  sharpCharts2StyleType: string;
  sharpCharts2StyleArgs: string;
};

export const PRICE_INDICATOR_STYLE_OPTION_AUTO: PriceIndicatorStyleOption = {
  title: '- Auto -',
  sharpCharts2StyleType: '',
  sharpCharts2StyleArgs: ''
};

export const PRICE_INDICATOR_STYLE_OPTION_CANDLESTICKS: PriceIndicatorStyleOption = {
  title: 'Candlesticks',
  sharpCharts2StyleType: 'candle',
  sharpCharts2StyleArgs: ''
};

export const PRICE_INDICATOR_STYLE_OPTION_OHLC: PriceIndicatorStyleOption = {
  title: 'OHLC Bars',
  sharpCharts2StyleType: 'ohlc',
  sharpCharts2StyleArgs: ''
};

export const PRICE_INDICATOR_STYLE_OPTION_OHLC_THICK: PriceIndicatorStyleOption = {
  title: 'OHLC Bars (thick)',
  sharpCharts2StyleType: 'ohlc',
  sharpCharts2StyleArgs: 'thick'
};

export const PRICE_INDICATOR_STYLE_OPTION_HLC: PriceIndicatorStyleOption = {
  title: 'HLC Bars',
  sharpCharts2StyleType: 'hlc',
  sharpCharts2StyleArgs: ''
};

export const PRICE_INDICATOR_STYLE_OPTION_HLC_THICK: PriceIndicatorStyleOption = {
  title: 'HLC Bars (thick)',
  sharpCharts2StyleType: 'hlc',
  sharpCharts2StyleArgs: 'thick'
};

export const PRICE_INDICATOR_STYLE_OPTION_SOLID: PriceIndicatorStyleOption = {
  title: 'Solid',
  sharpCharts2StyleType: 'line',
  sharpCharts2StyleArgs: '1.5,solid'
};

export const PRICE_INDICATOR_STYLE_OPTION_SOLID_THIN: PriceIndicatorStyleOption = {
  title: 'Solid (thin)',
  sharpCharts2StyleType: 'line',
  sharpCharts2StyleArgs: '1.0,solid'
};

export const PRICE_INDICATOR_STYLE_OPTION_SOLID_THICK: PriceIndicatorStyleOption = {
  title: 'Solid (thick)',
  sharpCharts2StyleType: 'line',
  sharpCharts2StyleArgs: '2.0,solid'
};

export const PRICE_INDICATOR_STYLE_OPTION_DASHED: PriceIndicatorStyleOption = {
  title: 'Dashed',
  sharpCharts2StyleType: 'line',
  sharpCharts2StyleArgs: '1.5,dash2'
};

export const PRICE_INDICATOR_STYLE_OPTION_DASHED_THIN: PriceIndicatorStyleOption = {
  title: 'Dashed (thin)',
  sharpCharts2StyleType: 'line',
  sharpCharts2StyleArgs: '1.0,dash2'
};

export const PRICE_INDICATOR_STYLE_OPTION_DASHED_THICK: PriceIndicatorStyleOption = {
  title: 'Dashed (thick)',
  sharpCharts2StyleType: 'line',
  sharpCharts2StyleArgs: '2.0,dash3'
};

export const PRICE_INDICATOR_STYLE_OPTION_DOTS: PriceIndicatorStyleOption = {
  title: 'Dots',
  sharpCharts2StyleType: 'dots',
  sharpCharts2StyleArgs: ''
};

export const PRICE_INDICATOR_STYLE_OPTION_AREA: PriceIndicatorStyleOption = {
  title: 'Area',
  sharpCharts2StyleType: 'area',
  sharpCharts2StyleArgs: '0.0,0.0'
};

export const PRICE_INDICATOR_STYLE_OPTION_HISTOGRAM: PriceIndicatorStyleOption = {
  title: 'Histogram',
  sharpCharts2StyleType: 'hist',
  sharpCharts2StyleArgs: '0.0'
};

export const PRICE_INDICATOR_STYLE_OPTION_INVISIBLE: PriceIndicatorStyleOption = {
  title: 'Invisible',
  sharpCharts2StyleType: 'invisible',
  sharpCharts2StyleArgs: ''
};

export const PRICE_INDICATOR_STYLE_OPTION_CUMULATIVE: PriceIndicatorStyleOption = {
  title: 'Cumulative',
  sharpCharts2StyleType: 'cumulative',
  sharpCharts2StyleArgs: '1.5,solid'
};

export const PRICE_INDICATOR_STYLE_OPTION_ELDER_IMPULSE_SYSTEM: PriceIndicatorStyleOption = {
  title: 'Elder Impulse System',
  sharpCharts2StyleType: 'ohlcelder',
  sharpCharts2StyleArgs: ''
};

export const DEFAULT_PRICE_INDICATOR_STYLE_OPTION: PriceIndicatorStyleOption = PRICE_INDICATOR_STYLE_OPTION_AUTO;

export const PRICE_INDICATOR_STYLE_OPTIONS_ARRAY: PriceIndicatorStyleOption[] = [
  PRICE_INDICATOR_STYLE_OPTION_AUTO,
  PRICE_INDICATOR_STYLE_OPTION_CANDLESTICKS,
  PRICE_INDICATOR_STYLE_OPTION_OHLC,
  PRICE_INDICATOR_STYLE_OPTION_OHLC_THICK,
  PRICE_INDICATOR_STYLE_OPTION_HLC,
  PRICE_INDICATOR_STYLE_OPTION_HLC_THICK,
  PRICE_INDICATOR_STYLE_OPTION_SOLID,
  PRICE_INDICATOR_STYLE_OPTION_SOLID_THIN,
  PRICE_INDICATOR_STYLE_OPTION_SOLID_THICK,
  PRICE_INDICATOR_STYLE_OPTION_DASHED,
  PRICE_INDICATOR_STYLE_OPTION_DASHED_THIN,
  PRICE_INDICATOR_STYLE_OPTION_DASHED_THICK,
  PRICE_INDICATOR_STYLE_OPTION_DOTS,
  PRICE_INDICATOR_STYLE_OPTION_AREA,
  PRICE_INDICATOR_STYLE_OPTION_HISTOGRAM,
  PRICE_INDICATOR_STYLE_OPTION_INVISIBLE,
  PRICE_INDICATOR_STYLE_OPTION_CUMULATIVE,
  PRICE_INDICATOR_STYLE_OPTION_ELDER_IMPULSE_SYSTEM
];

export function getPriceIndicatorStyleObjFromPriceIndicatorStyleTitle(priceIndicatorStyleTitle: string): PriceIndicatorStyleOption {
  return PRICE_INDICATOR_STYLE_OPTIONS_ARRAY.find(option => option.title === priceIndicatorStyleTitle) ?? DEFAULT_PRICE_INDICATOR_STYLE_OPTION;
}
